export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};

const integerFormatter = new Intl.NumberFormat();

export const formatInteger = (n: number) => integerFormatter.format(n);

export const formatNumeric = (value: unknown) => {
  if (typeof value === 'number') return Number.isFinite(value) ? formatInteger(value) : '-';

  return String(value ?? '');
};

export const formatTooltipValue = (value: unknown): string | string[] =>
  Array.isArray(value) ? value.map(formatNumeric) : formatNumeric(value);

export const abbreviateNumber = (n: number) => {
  const formatter = Intl.NumberFormat('en', { notation: 'compact' });

  return formatter.format(n);
};

export const manyOrNumber = (count: number = 0, limit: number = 10000) =>
  limit && count >= limit ? `+${abbreviateNumber(limit)}` : abbreviateNumber(count);
